class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1199px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const initFloatingLogoAnimation = () => {
      const sourceLogoWrapper = document.querySelector('[data-scroll-logo], .girnar-categories__left-logo-wrapper, #GirnarLogoWrapper');
      const headerHeading = document.querySelector('.header__heading');

      if (!sourceLogoWrapper || !headerHeading) return;

      const sourceImg = sourceLogoWrapper.querySelector('img') || sourceLogoWrapper;

      // Create fixed body-level floating animator container
      let floatingContainer = document.getElementById('FloatingLogoAnimator');
      if (!floatingContainer) {
        floatingContainer = document.createElement('div');
        floatingContainer.id = 'FloatingLogoAnimator';
        floatingContainer.style.cssText = 'position:fixed;top:0;left:0;z-index:99999;pointer-events:none;will-change:transform,opacity,width,height;display:none;';
        const floatingImg = document.createElement('img');
        floatingImg.src = sourceImg.getAttribute('src') || sourceImg.src;
        floatingImg.alt = sourceImg.alt || 'Logo';
        floatingImg.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;margin:0;padding:0;';
        floatingContainer.appendChild(floatingImg);
        document.body.appendChild(floatingContainer);
      }

      headerHeading.style.transition = 'none';
      headerHeading.style.willChange = 'opacity';
      sourceImg.style.transition = 'opacity 0.1s ease';

      const isDesktop = () => window.innerWidth >= 1200;

      const resetForMobile = () => {
        if (floatingContainer) floatingContainer.style.display = 'none';
        sourceImg.style.opacity = '1';
        headerHeading.style.opacity = '1';
        headerHeading.style.visibility = 'visible';
        headerHeading.style.pointerEvents = 'auto';
        state = 'at_top';
      };

      const DURATION = 1200; // ms for flight animation
      const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

      let state = 'at_top'; // 'at_top', 'animating_down', 'at_header', 'animating_up'

      // Play animation FROM section TO header
      const animateToHeader = () => {
        if (!isDesktop() || state !== 'at_top') return;
        state = 'animating_down';

        const sRect = sourceLogoWrapper.getBoundingClientRect();
        const startLeft = sRect.left;
        const startTop = sRect.top;
        const startWidth = sRect.width;
        const startHeight = sRect.height;

        floatingContainer.style.display = 'block';
        floatingContainer.style.opacity = '1';
        floatingContainer.style.transform = `translate3d(${startLeft}px, ${startTop}px, 0)`;
        floatingContainer.style.width = `${startWidth}px`;
        floatingContainer.style.height = `${startHeight}px`;
        sourceImg.style.opacity = '0';

        const startTime = performance.now();

        const step = (now) => {
          const elapsed = now - startTime;
          const rawProgress = Math.min(elapsed / DURATION, 1);
          const p = ease(rawProgress);

          const hRect = headerHeading.getBoundingClientRect();
          const currentLeft = startLeft + (hRect.left - startLeft) * p;
          const currentTop = startTop + (hRect.top - startTop) * p;
          const currentWidth = startWidth + (hRect.width - startWidth) * p;
          const currentHeight = startHeight + (hRect.height - startHeight) * p;

          floatingContainer.style.transform = `translate3d(${currentLeft}px, ${currentTop}px, 0)`;
          floatingContainer.style.width = `${currentWidth}px`;
          floatingContainer.style.height = `${currentHeight}px`;

          if (p < 0.85) {
            floatingContainer.style.opacity = '1';
            headerHeading.style.opacity = '0';
            headerHeading.style.visibility = 'hidden';
          } else {
            const fade = (p - 0.85) / 0.15;
            floatingContainer.style.opacity = `${1 - fade}`;
            headerHeading.style.visibility = 'visible';
            headerHeading.style.opacity = `${fade}`;
          }

          if (rawProgress < 1) {
            requestAnimationFrame(step);
          } else {
            floatingContainer.style.display = 'none';
            headerHeading.style.opacity = '1';
            headerHeading.style.visibility = 'visible';
            headerHeading.style.pointerEvents = 'auto';
            state = 'at_header';
          }
        };

        requestAnimationFrame(step);
      };

      // Play animation FROM header BACK TO section
      const animateToSection = () => {
        if (!isDesktop() || state !== 'at_header') return;
        state = 'animating_up';

        const hRect = headerHeading.getBoundingClientRect();
        const startLeft = hRect.left;
        const startTop = hRect.top;
        const startWidth = hRect.width;
        const startHeight = hRect.height;

        floatingContainer.style.display = 'block';
        floatingContainer.style.opacity = '1';
        floatingContainer.style.transform = `translate3d(${startLeft}px, ${startTop}px, 0)`;
        floatingContainer.style.width = `${startWidth}px`;
        floatingContainer.style.height = `${startHeight}px`;

        headerHeading.style.opacity = '0';
        headerHeading.style.visibility = 'hidden';
        headerHeading.style.pointerEvents = 'none';

        const startTime = performance.now();

        const step = (now) => {
          const elapsed = now - startTime;
          const rawProgress = Math.min(elapsed / DURATION, 1);
          const p = ease(rawProgress);

          const sRect = sourceLogoWrapper.getBoundingClientRect();
          const currentLeft = startLeft + (sRect.left - startLeft) * p;
          const currentTop = startTop + (sRect.top - startTop) * p;
          const currentWidth = startWidth + (sRect.width - startWidth) * p;
          const currentHeight = startHeight + (sRect.height - startHeight) * p;

          floatingContainer.style.transform = `translate3d(${currentLeft}px, ${currentTop}px, 0)`;
          floatingContainer.style.width = `${currentWidth}px`;
          floatingContainer.style.height = `${currentHeight}px`;
          floatingContainer.style.opacity = '1';

          if (rawProgress < 1) {
            requestAnimationFrame(step);
          } else {
            floatingContainer.style.display = 'none';
            sourceImg.style.opacity = '1';
            state = 'at_top';
          }
        };

        requestAnimationFrame(step);
      };

      // Scroll listener to check state and trigger appropriate animation on desktop only
      const onScroll = () => {
        if (!isDesktop()) {
          resetForMobile();
          return;
        }

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > 20 && state === 'at_top') {
          animateToHeader();
        } else if (scrollTop <= 10 && state === 'at_header') {
          animateToSection();
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      // Run initial check
      if (!isDesktop()) {
        resetForMobile();
      } else {
        headerHeading.style.opacity = '0';
        headerHeading.style.visibility = 'hidden';
        headerHeading.style.pointerEvents = 'none';
        onScroll();
      }
    };

    initFloatingLogoAnimation();

    const initHeaderMenuOverflow = () => {
      const navs = document.querySelectorAll('.header__inline-menu');
      if (!navs.length) return;

      navs.forEach((nav) => {
        const list = nav.querySelector('.list-menu--inline');
        if (!list) return;

        const moreWrapper = list.querySelector('[data-more-menu]');
        if (!moreWrapper) return;

        const mainItems = Array.from(list.querySelectorAll(':scope > li[data-menu-index]'));
        const moreItems = Array.from(moreWrapper.querySelectorAll('[data-more-index]'));

        if (!mainItems.length) return;

        const updateOverflow = () => {
          if (window.getComputedStyle(nav).display === 'none') return;

          /* Calculate max available width for left navigation */
          const headerEl = nav.closest('.header');
          let maxNavWidth = 0;

          if (headerEl) {
            const logoEl = headerEl.querySelector('.header__heading, .header__heading-link');
            const iconsEl = headerEl.querySelector('.header__icons');
            const logoW = logoEl ? logoEl.offsetWidth : 0;
            const iconsW = iconsEl ? iconsEl.offsetWidth : 0;

            const headerStyle = window.getComputedStyle(headerEl);
            const pLeft = parseFloat(headerStyle.paddingLeft) || 0;
            const pRight = parseFloat(headerStyle.paddingRight) || 0;
            const headerContentWidth = headerEl.clientWidth - pLeft - pRight;

            if (headerEl.classList.contains('header--middle-center')) {
              // Space from left edge to center logo
              const calcMax = (headerContentWidth - logoW) / 2 - 24;
              if (calcMax > 0) maxNavWidth = calcMax;
            } else {
              const calcMax = headerContentWidth - logoW - iconsW - 40;
              if (calcMax > 0) maxNavWidth = calcMax;
            }
          }

          if (!maxNavWidth) {
            maxNavWidth = nav.clientWidth || 400;
          }

          /* Measure main item widths */
          moreWrapper.style.display = 'inline-flex';
          mainItems.forEach((item) => {
            item.style.display = 'inline-flex';
          });

          const moreWidth = moreWrapper.offsetWidth || 80;
          const itemWidths = mainItems.map((item) => item.offsetWidth || item.getBoundingClientRect().width);
          const totalMainWidth = itemWidths.reduce((sum, w) => sum + w, 0);

          /* If all items fit, hide More */
          if (totalMainWidth <= maxNavWidth) {
            moreWrapper.style.display = 'none';
            mainItems.forEach((item) => (item.style.display = ''));
            moreItems.forEach((item) => (item.style.display = 'none'));
            nav.classList.add('is-initialized');
            return;
          }

          /* Calculate overflow index */
          const availableWidth = maxNavWidth - moreWidth - 10;
          let accumulatedWidth = 0;
          let overflowStartIndex = mainItems.length;

          for (let i = 0; i < mainItems.length; i++) {
            if (accumulatedWidth + itemWidths[i] > availableWidth) {
              overflowStartIndex = i;
              break;
            }
            accumulatedWidth += itemWidths[i];
          }

          mainItems.forEach((item, index) => {
            item.style.display = index < overflowStartIndex ? '' : 'none';
          });

          moreItems.forEach((item, index) => {
            item.style.display = index >= overflowStartIndex ? 'block' : 'none';
          });

          moreWrapper.style.display = 'inline-flex';
          nav.classList.add('is-initialized');
        };

        let rAFId = null;
        const scheduleUpdate = () => {
          if (rAFId) cancelAnimationFrame(rAFId);
          rAFId = requestAnimationFrame(updateOverflow);
        };

        const headerEl = nav.closest('.header') || nav;
        if (typeof ResizeObserver !== 'undefined') {
          const resizeObserver = new ResizeObserver(scheduleUpdate);
          resizeObserver.observe(headerEl);
        } else {
          window.addEventListener('resize', scheduleUpdate);
          window.addEventListener('orientationchange', scheduleUpdate);
        }

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(scheduleUpdate);
        }

        document.addEventListener('shopify:section:load', scheduleUpdate);
        scheduleUpdate();
      });
    };

    initHeaderMenuOverflow();
  });